<template>
  <div class="card">
    <img class="card-img-top" v-bind:src="imageUrl" alt="Card image cap" v-on:click="showPhotosModal">
    <photos-modal ref="photosModal" :photos="photos" :image-url="imageUrl" :photo="imageIndex"></photos-modal>
  </div>
</template>

<script>
import photosModal from './PhotosModal.vue'

export default {
  props: {
    imageUrl: String,
    photos: Array,
    imageIndex: Number
  },
  components: {
    photosModal
  },
  methods: {
    showPhotosModal () {
      this.$refs.photosModal.$refs.photosModal.show()
      this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    }
  }
}
</script>

<style scoped>
.card {
  margin: .5rem !important;
  height: 250px;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: unset;
  border: 0px;
  border-radius: 10px;
}

.card-img-top {
  object-fit: cover;
  cursor: pointer;
  height: 250px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/PhotoCard.vue